// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import classnames from 'classnames'


import PropTypes from 'prop-types'

import { Motion, spring } from 'react-motion'
import { Link } from 'react-router'

import 'styles/components/NotificationBar.styl'

const NOTIFICATION_DISPLAY_DURATION = 5000

const NotificationBar = React.createClass({

  getDefaultProps() {
    return {
      variant: 'green'
    }
  },

  dismissNotification() {
    clearTimeout(this.delayedDismissal)
    return this.app.actions.NotificationActions.dismissNotification()
  },

  undoNotification(notification) {
    notification.undoAction()
    return this.dismissNotification()
  },

  render() {
    if (this.props.notifications.length) {
      const notification = _.head(this.props.notifications)
      if (!notification.sticky) {
        this.delayedDismissal = setTimeout(this.dismissNotification, notification.displayTime || NOTIFICATION_DISPLAY_DURATION)
      }

      return (
        <Motion>
          {interpolated => {
            return (
              <div
                className={classnames('NotificationBar', notification.variant)}
                style={{ top: `${ interpolated.top }rem` }}>
                <div className="notification-content">
                  {notification.content}
                </div>
                {notification.viewLinkTo ?
                  <Link onClick={this.dismissNotification} to={notification.viewLinkTo}>
                    <button className="dsg-SmallButton">
                      View
                    </button>
                  </Link> : undefined}
                {notification.undoAction ?
                  <button
                    className="dsg-SmallButton"
                    onClick={this.undoNotification.bind(this, notification)}>
                    Undo
                  </button> : undefined}
                {notification.actioNode ? notification.actioNode : undefined}
                <img
                  src={require('images/icons/times-icon-gray.svg')}
                  onClick={this.dismissNotification} />
              </div>
            )
          }}
        </Motion>
      )

    } else {
      return <div />
    }
  }
})

NotificationBar.displayName = 'NotificationBar'
NotificationBar.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['red', 'gray', 'green', 'blue']),
    viewLinkTo: PropTypes.object,
    displayTime: PropTypes.number,
    undoAction: PropTypes.func
  }).isRequired)
}

const NotificationBarContainer = Marty.createContainer(NotificationBar, {
  listenTo: ['stores.NotificationStore'],
  fetch: {
    notifications() {
      return this.app.stores.NotificationStore.getNotifications()
    }
  }
})

export default NotificationBarContainer



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationBar.js